module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showclose),
      expression: "showclose"
    }],
    attrs: {
      "i": "right_function"
    }
  }, [_c('div', {
    staticClass: "right-top"
  }, [_c('div', {
    staticClass: "right_close",
    on: {
      "click": function($event) {
        _vm.showclose = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "down-app"
  }, [_c('a', {
    attrs: {
      "href": _vm.donw_url.url,
      "target": "view_window"
    }
  }, [_c('div', {
    staticClass: "down-qrod"
  }, [_c('img', {
    attrs: {
      "src": _vm.donw_url.qr_code
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "down-text"
  }, [_vm._v("\n\t\t\t\t\t\t下载app\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "customer-chat",
    on: {
      "mouseover": function($event) {
        _vm.hover = true;
      },
      "mouseout": function($event) {
        _vm.hover = false
      },
      "click": function($event) {
        return _vm.MEIQIA()
      }
    }
  }, [_c('div', {
    staticClass: "chat-img"
  }, [(_vm.hover) ? _c('img', {
    attrs: {
      "src": "/static/images/chatb.png",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/images/chat.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chat-text",
    class: {
      'active': _vm.hover
    },
    on: {
      "click": _vm.show
    }
  }, [_vm._v("\n\t\t\t\t\t在线客服\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "go-top",
    on: {
      "click": _vm.scroo
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/top.png"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Return-top "
  }, [_c('div', {
    staticClass: "bolang-img bg-cover"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-aa400f76!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Right.vue
// module id = 943
// module chunks = 42